module.exports = __webpack_public_path__ + "img/shishikecheng.707ac192.png";